import ClassenService from '../ClassenService';

class PackageService {
  getPackages() {
    return ClassenService.doApiCall('get', `${process.env.VUE_APP_API}/packages`);
  }

  addPackage(packageData) {
    return ClassenService.doApiCall('post', `${process.env.VUE_APP_API}/packages`, 'addPackage', packageData);
  }

  getPackage(packageId) {
    return ClassenService.doApiCall('get', `${process.env.VUE_APP_API}/packages/${packageId}`);
  }

  getPackagesArticleExport(packageId) {
    return ClassenService.doApiCall('get', `${process.env.VUE_APP_API}/packages/${packageId}/export/articles`);
  }

  updatePackage(packageId, packageData) {
    return ClassenService.doApiCall('put', `${process.env.VUE_APP_API}/packages/${packageId}`, 'updatePackage', packageData);
  }

  deletePackage(packageId) {
    return ClassenService.doApiCall('delete', `${process.env.VUE_APP_API}/packages/${packageId}`, 'deletePackage');
  }

  getPackagesFacets() {
    return ClassenService.doApiCall('get', `${process.env.VUE_APP_API}/packages/facets`);
  }

  getPackagesAsset(packageId) {
    return ClassenService.doApiCall('get', `${process.env.VUE_APP_API}/package/assets`);
  }

  addPackageAsset(packageId, assetData) {
    return ClassenService.doApiCall('post', `${process.env.VUE_APP_API}/package/assets`, 'addPackageAsset', assetData);
  }

  getPackageAsset(packageId, assetId) {
    return ClassenService.doApiCall('get', `${process.env.VUE_APP_API}/package/assets/${assetId}`);
  }

  updatePackageAsset(packageId, assetId, assetData) {
    return ClassenService.doApiCall('put', `${process.env.VUE_APP_API}/package/assets${assetId}`, 'updatePackageAsset', assetData);
  }

  deletePackageAsset(packageId, assetId) {
    return ClassenService.doApiCall('delete', `${process.env.VUE_APP_API}/package/assets${assetId}`, 'deletePackageAsset');
  }

  searchPackages(page = 1, size = 16, searchData) {
    return ClassenService.doApiCall('post', `${process.env.VUE_APP_API}/packages/search?page[size]=${size}&page[number]=${page}`, 'searchData', searchData);
  }

  getProductsFacets() {
    return ClassenService.doApiCall('get', `${process.env.VUE_APP_API}/packages/facets`);
  }
}

export default new PackageService();
